import Principal from "./pages";

function App() {
  return (
    <Principal />
  );
}


export default App;
